module.exports = __webpack_public_path__ + "static/media/p6detail.488dec29.jpg";